import { render, staticRenderFns } from "./AlertMsg.vue?vue&type=template&id=77545b3e&"
import script from "./AlertMsg.vue?vue&type=script&lang=ts&"
export * from "./AlertMsg.vue?vue&type=script&lang=ts&"
import style0 from "./AlertMsg.vue?vue&type=style&index=0&id=77545b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports